// store/types.js
export const RESET_STATES = 'resetStates'
